module.exports = __webpack_public_path__ + "img/dotLight.9d020986.svg";